import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAnalyticsReportBase } from '../../../hooks/useAnalyticsReportBase';
import { useExportAnalyticsReportCSV } from '../../../hooks/useExportAnalyticsReportCSV';
import { useReportSeries } from '../../../hooks/useReportSeries';
import { useReportTableSorting } from '../../../hooks/useReportTableSorting';
import { useAnalyticsParams } from '../../../modules/AnalyticsParams/hooks/useAnalyticsParams';
import { useAnalyticsReportCard } from './useAnalyticsReportCard';
import { useAnalyticsReportTable } from './useAnalyticsReportTable';
import { createAnalyticsTableColumns } from './utils/createAnalyticsTableColumns';
export const useAnalyticsReport = () => {
    const { reportId } = useParams();
    const params = useAnalyticsParams();
    const { exportReportCSV } = useExportAnalyticsReportCSV();
    const [isExporting, setIsExporting] = useState(false);
    const { reportDefinition, isReportDefinitionLoading, reportData, isReportDataLoading } = useAnalyticsReportBase({
        reportId: reportId || '',
    });
    const columns = createAnalyticsTableColumns(reportDefinition?.columns || [], params.groupBy.value.value);
    const { activeSeries, setActiveSeries, headerOptions } = useReportSeries(columns, reportDefinition?.yAxisDefaultValue || '');
    const { sorting, onSortingChange } = useReportTableSorting(columns);
    const card = useAnalyticsReportCard({
        reportData,
        isReportDataLoading,
        isReportDefinitionLoading,
        columns,
        reportDefinition,
        activeSeries,
        setActiveSeries,
        headerOptions: headerOptions || [],
    });
    const table = useAnalyticsReportTable({
        reportData,
        isLoading: isReportDataLoading,
        columns,
        sorting,
        activeSeries,
        onSortingChange,
    });
    const handleExport = async () => {
        if (!reportDefinition) {
            return;
        }
        setIsExporting(true);
        await exportReportCSV(reportDefinition.id);
        setIsExporting(false);
    };
    return {
        enabled: isReportDefinitionLoading || reportDefinition,
        isLoading: isReportDefinitionLoading,
        reportId,
        title: reportDefinition?.name || 'Report',
        card,
        table,
        isExporting,
        onExport: handleExport,
    };
};
